import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";

const CONTENT = {
  privacy: {
    eyebrow: "Legal", title: "Privacy Policy",
    body: [
      ["What we collect", "To prepare your report we collect your full name, date of birth, email address, and any optional details you provide (birth time, birthplace, preferred language, areas of interest, alternative spellings). We collect payment confirmation data from our gateway but never store card numbers or CVV."],
      ["How we use it", "Your information is used solely to calculate your numerology results, generate your report, deliver it by email, and provide support. We do not sell your data."],
      ["Advertising & analytics", "We may use privacy-conscious analytics to understand aggregate usage. We never send your name, date of birth, birthplace, email, or report contents to advertising platforms."],
      ["Storage & security", "Personal details and generated reports are stored securely with restricted access. Report downloads use private, non-guessable links. We apply reasonable technical and organizational safeguards."],
      ["Retention & deletion", "We retain order records as needed for support, accounting, and legal obligations. You may request deletion of your personal data by contacting support, subject to applicable legal requirements."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal information. Contact us via the Contact page."],
    ],
  },
  terms: {
    eyebrow: "Legal", title: "Terms & Conditions",
    body: [
      ["Nature of the service", "Aetheria provides personalized numerology reports generated using documented methodologies and automated report-writing technology. Reports are for personal reflection and entertainment, and are not professional advice."],
      ["No guarantees", "We do not guarantee any real-world outcomes relating to wealth, health, relationships, career, or life events. Numerology is a traditional interpretive practice, not a scientifically established predictive method."],
      ["Orders & payment", "By placing an order you confirm the details you submit are accurate and that you accept these terms. Payment is processed in INR and verified before your report is prepared."],
      ["Delivery", "Reports are typically delivered by email within approximately 6–7 hours of confirmed payment. Delivery times are estimates."],
      ["Acceptable use", "You agree not to misuse the service, submit unlawful content, or attempt to access other customers' orders or our systems."],
      ["Liability", "To the extent permitted by law, our liability is limited to the amount paid for your order."],
    ],
  },
  refund: {
    eyebrow: "Legal", title: "Refund & Cancellation Policy",
    body: [
      ["Personalized digital products", "Reports are personalized digital products prepared specifically for you. Once a report has been generated and delivered, it generally cannot be refunded."],
      ["Before generation", "If you contact us before your report has been generated, we can usually cancel the order and issue a refund to the original payment method."],
      ["Problems with your order", "If your report failed to generate, did not arrive, or contained a genuine error on our part, contact support with your Order ID. We will investigate and, where appropriate, regenerate the report or issue a refund."],
      ["How refunds are processed", "Approved refunds are returned to your original payment method through our payment gateway. Processing times depend on your bank or provider."],
      ["How to request", "Email our support team via the Contact page and include your Order ID (AET-…) and a short description of the issue."],
    ],
  },
  disclaimer: {
    eyebrow: "Important", title: "Numerology Disclaimer",
    body: [
      ["For reflection only", "The content of Aetheria reports is intended for personal reflection and entertainment. Numerology is a traditional interpretive practice and is not a scientifically established predictive method."],
      ["Not professional advice", "Our reports are not a substitute for professional medical, legal, financial, psychological, or relationship advice. Always consult a qualified professional for such matters."],
      ["No guaranteed outcomes", "We make no promises or guarantees regarding wealth, health, marriage, career, or any other real-world outcome, including in relation to name spellings."],
      ["Automated generation", "Reports are produced using documented numerology methodologies and automated report-writing technology. They are not written or reviewed by a human unless explicitly stated."],
      ["Your decisions", "Any decisions you make based on a report are your own responsibility."],
    ],
  },
};

export default function LegalPage({ slug }) {
  const c = CONTENT[slug];
  if (!c) return null;
  return (
    <>
      <Seo title={c.title} path={`/${slug}`} />
      <PageHeader eyebrow={c.eyebrow} title={c.title} />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20 space-y-8">
        {c.body.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-serif text-2xl text-navy mb-2">{h}</h2>
            <p className="text-slate-600 leading-relaxed">{p}</p>
          </div>
        ))}
        <p className="text-xs text-slate-400 pt-4 border-t border-border">
          This document is provided for general information and should be reviewed by qualified legal
          counsel before commercial use, including for applicable Indian privacy, consumer-protection,
          and tax requirements.
        </p>
      </section>
    </>
  );
}
